import { createSelector } from '@reduxjs/toolkit'
import { GlobalState } from 'store'
import { DealPreloadState } from './spreadsheetUploadReducer'

const spreadsheetUploadSelector = (state: GlobalState) => state.spreadsheetUploadStore

export const dealPreloadStateSelector = createSelector(
  spreadsheetUploadSelector,
  spreadsheetUploadStore => spreadsheetUploadStore.dealPreloadState
)

export const dealPreloadHasError = (state: DealPreloadState) => state === DealPreloadState.ERROR
export const dealPreloadHasCompleted = (state: DealPreloadState) => state === DealPreloadState.COMPLETE
export const dealPreloadIsLoading = (state: DealPreloadState) => state === DealPreloadState.LOADING
